import React from "react";
import MuiLoadingButton from "@mui/lab/LoadingButton";

import { Box, CircularProgress } from "@mui/material";
import Color from "../theme/color";

const LoadingButton = ({
  float = "right",
  fullWidthMobile = false,
  loading = false,
  disabled = loading,
  backgroundColor = sessionStorage.getItem("buttonBackground") ||
    Color.digipass,
  ...props
}) => (
  <MuiLoadingButton
    {...props}
    variant="contained"
    color="primary"
    sx={{
      fontSize: "16px",
      float: float,
      fontWeight: 600,
      fontStyle: "normal",
      borderRadius: "28px",
      backgroundColor: loading ? "grey" : backgroundColor,
      color: sessionStorage.getItem("buttonColor") || "#FFF",
      width: "100%",
      "@media (min-width: 1000px)": {
        width: "100%",
      },
      "@media (max-width: 420px)": {
        fontSize: "12px !important",
        padding: "8px !important",
      },
      "&:hover": {
        backgroundColor: loading ? "grey" : backgroundColor,
        borderRadius: "28px",
      },
    }}
    disabled={disabled}
    loading={loading}
    loadingIndicator={
      <Box
        sx={{ display: "flex", alignItems: "center", gap: 1, color: "black" }}
      >
        Please wait…
        <CircularProgress size={20} color="inherit" />
      </Box>
    }
  >
    {props.children}
  </MuiLoadingButton>
);

export default LoadingButton;
